import Register from 'components/Auth/Register';
import React, { FC } from 'react';
import {
  NavLink,
  Switch,
  Route,
  useLocation,
  useHistory,
  Redirect,
} from 'react-router-dom';
import { routeMap, useNavigate, useParamsAndSearch } from 'routeMap';
import { AwsAuthenticator } from 'toolbox';
import { useAuthWrapperContext } from 'toolbox/src/components/AuthWrapper/AuthWrapper';
import { ConfirmSignIn } from './ConfirmSignIn';
import { ConfirmSignUp } from './ConfirmSignUp';
import { ForgotPassword } from './ForgotPassword';
import { RequireNewPassword } from './RequireNewPassword';
import { SignIn } from './SignIn';
import { VerifyContact } from './VerifyContact';

export const Authenticator: FC = () => {
  const location = useLocation();
  const history = useHistory();
  const navigate = useNavigate();
  const { status, refreshAuthState, user, username } = useAuthWrapperContext();

  const {
    search,
  }: { params?: {}; search?: { returnTo?: string } } = useParamsAndSearch(
    'authenticatorRoot',
  );
  const returnTo = String(search?.returnTo || '');

  return (
    <div className="relative w-full h-full login-bg">
      <aside className="absolute right-0 flex items-center justify-center w-full h-full md:max-w-lg">
        <Switch>
          <Route exact path="/auth/register" component={Register} />
          <Route exact path="/auth/confirm-signup" component={ConfirmSignUp} />
          <Route>
            <AwsAuthenticator
              components={{
                confirmSignIn: ConfirmSignIn,
                forgotPassword: ForgotPassword,
                requireNewPassword: RequireNewPassword,
                signIn: SignIn,
                verifyContact: VerifyContact,
                pending: () => null,
                signedIn: () => (
                  <Redirect to={returnTo ? returnTo : routeMap.home()} />
                ),
              }}
              isLoggedIn={status === 'loggedIn'}
              onLogInSuccess={async () => {
                refreshAuthState();
                returnTo ? history.push(returnTo) : navigate.home();
              }}
              onUserNotConfirmedException={(username) => {
                console.log(username);
                navigate.confirmSignUp({
                  search: {
                    username: String(username),
                  },
                });
              }}
            />
          </Route>
        </Switch>

        <div className="absolute bottom-0 z-10 mb-4 text-gray-100">
          <NavLink
            to="/auth/register"
            className="mr-5 font-semibold hover:underline"
          >
            Click Here to Register
          </NavLink>
          |
          <a
            href="http://jcap.co.uk/wp-content/uploads/2018/05/JCAP-Privacy-Statement-pdf-version.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="ml-5 font-semibold hover:underline"
          >
            Privacy Notice
          </a>
          <div className="mt-2 text-sm text-center opacity-50">
            {process.env.REACT_APP_VERSION && (
              <>Version {process.env.REACT_APP_VERSION}</>
            )}
          </div>
        </div>

        <div className="absolute inset-0 z-0 shadow-xl bg-frost-400 bg-blur" />
      </aside>
    </div>
  );
};
